/**
 * @generated SignedSource<<18447534f3f88ef5dc38d784df90549d>>
 * @relayHash 923b3a0cc62d702329135466ee6ed542
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9bc5bb7a9cb65d7601583747fa24fc64d2a9b0aeeb3d7be0625fc77f76e83c9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useSetSelectedGroupingOldMutation$variables = {
  fieldId?: string | null | undefined;
  viewId: string;
};
export type useSetSelectedGroupingOldMutation$data = {
  readonly jira: {
    readonly updateIssueSearchGroupByConfig: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSetSelectedGroupingOldMutation = {
  response: useSetSelectedGroupingOldMutation$data;
  variables: useSetSelectedGroupingOldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v2 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "fieldId",
            "variableName": "fieldId"
          },
          {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
          }
        ],
        "concreteType": "JiraIssueSearchGroupByFieldMutationPayload",
        "kind": "LinkedField",
        "name": "updateIssueSearchGroupByConfig",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSetSelectedGroupingOldMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSetSelectedGroupingOldMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "d9bc5bb7a9cb65d7601583747fa24fc64d2a9b0aeeb3d7be0625fc77f76e83c9",
    "metadata": {},
    "name": "useSetSelectedGroupingOldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a731023d2c60df2dbf21e0f2d0a2a2a8";

export default node;
